import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onFetchProducts, onSetSelectedProduct, selectProductState, setAction, setTotalRows } from "../redux/slices/productSlice"
import { ProductsAPI } from "../apis/ProductsAPI"
import { Product } from "../types/slices/productType"

export const useProductStore = () => {

    const dispatch = useDispatch()
    const { products, productSelected, status, action, totalRows } = useSelector(selectProductState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getProducts = async (data: {}) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.getProducts(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail, total } = response.data
            dispatch(onFetchProducts(detail || []))
            dispatch(setTotalRows(total || 0))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getProductsByCompany = async (data: {}) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.getProductsByCompany({ ...data, idcompany: idcompany })
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail, total } = response.data
            dispatch(onFetchProducts(detail || []))
            dispatch(setTotalRows(total || 0))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getTypeProducts = async (search = '') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.getTypeProducts({ search: search })
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getTypesCoin = async (search = '') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.getTypesCoin({ search: search })
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createProduct = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.createProduct(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editProduct = async (idproduct: number, data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.editProduct(idproduct, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteProduct = async (idproduct: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.deleteProduct(idproduct)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const downloadTemplate = async () => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.downloadTemplate()
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const importProducts = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.importProducts(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response?.data?.message || "Ocurrio algún problema en la importación.");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const exportProducts = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.exportProducts(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedProduct = (product: Product) => {
        try {
            dispatch(onSetSelectedProduct(product))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionProduct = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    const updateCostMasive = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductsAPI.updateCostMasive(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    return {
        //states
        products,
        productSelected,
        status,
        action,
        totalRows,
        //actions
        getProducts,
        getProductsByCompany,
        getTypeProducts,
        getTypesCoin,
        createProduct,
        editProduct,
        deleteProduct,
        downloadTemplate,
        importProducts,
        exportProducts,
        setSelectedProduct,
        setActionProduct,
        updateCostMasive
    }
}